import React from 'react';
import PropTypes from 'prop-types';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import _isEmpty from 'lodash/isEmpty';

import 'codemirror/mode/javascript/javascript';
import './style.css';

const RawData = ({
  json,
  title,
  className,
  theme,
  lineWrapping,
  onSetEditor,
}) => {
  return (
    <>
      {title && (
        <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold mb-5">
          {title}
        </h2>
      )}
      <div className="mb-8 w-full">
        <CodeMirror
          value={json}
          className={!_isEmpty(JSON.parse(json)) ? className : 'hasNoData'}
          editorDidMount={onSetEditor}
          onChange={onSetEditor}
          options={{
            mode: { name: 'javascript', json: true },
            theme,
            lineNumbers: true,
            indentWithTabs: true,
            readOnly: true,
            cursorHeight: '0.85',
            lineWrapping,
          }}
        />
      </div>
    </>
  );
};

RawData.propTypes = {
  json: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.string,
  lineWrapping: PropTypes.bool,
  onSetEditor: PropTypes.func,
};
RawData.defaultProps = {
  json: '{}',
  title: '',
  className: '',
  theme: 'dracula',
  lineWrapping: false,
};

export default RawData;
